import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableIncomesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter
        var vthis = this; // Preserve context for inner functions

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Editar', // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('accountingIncomePrint', 'Edit')) {
                                            return "<span class='webix_icon wxi-close printer'></span>"; // Return icon if permission granted
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: true, // Hide this column
                                },
                                {
                                    id: 'Consecutive', // Column ID
                                    header: _('Consecutivo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Column ID
                                    header: _('Descripción'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de Creación'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'BetShop', // Column ID
                                    header: _('Punto de Venta'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserCreated', // Column ID
                                    header: _('Creador'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DocumentID', // Column ID
                                    header: _('Documento ID'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Account', // Column ID
                                    header: _('Cuenta'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Concept', // Column ID
                                    header: _('Concepto'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Retraction', // Column ID
                                    header: _('Retracción'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('EditIncomes').show(); // Show edit window
                                },
                                printer: function (euv, id) {
                                    // Click event for print action
                                    var vvthis = this; // Preserve context
                                    var item = vvthis.getItem(id); // Get clicked item
                                    webix
                                        .ajax() // AJAX request to print incomes
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/PrintIncomes',
                                            '{ "Id":' + item.Id + '}', // Send item ID
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    data = JSON.parse(text); // Parse response
                                                    webix
                                                        .ui({
                                                            view: 'window', // Create a window for displaying the PDF
                                                            head: {
                                                                view: 'toolbar',
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _('Soporte'), // Window title
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        label: 'X', // Close button
                                                                        width: 100,
                                                                        align: 'right',
                                                                        click: "$$('windowfact2').close();", // Close action
                                                                    },
                                                                ],
                                                            },
                                                            id: 'windowfact2', // Window ID
                                                            modal: true, // Modal window
                                                            position: 'center', // Center position
                                                            body: {
                                                                rows: [
                                                                    {
                                                                        template:
                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show the window
                                                    var reader = new FileReader(); // FileReader for reading the PDF
                                                    reader.onload = function (event) {
                                                        $$('pdf').clear(); // Clear previous PDF
                                                        $$('pdf').parse({
                                                            data: event.target.result, // Parse new PDF data
                                                        });
                                                    };
                                                    function b64toBlob(b64Data, contentType, sliceSize) {
                                                        contentType = contentType || ''; // Default content type
                                                        sliceSize = sliceSize || 512; // Default slice size
                                                        var byteCharacters = atob(b64Data); // Decode base64
                                                        var byteArrays = []; // Array for byte arrays
                                                        for (
                                                            var offset = 0;
                                                            offset < byteCharacters.length;
                                                            offset += sliceSize
                                                        ) {
                                                            var slice = byteCharacters.slice(
                                                                offset,
                                                                offset + sliceSize,
                                                            ); // Slice byte characters
                                                            var byteNumbers = new Array(slice.length); // Create byte numbers array
                                                            for (var i = 0; i < slice.length; i++) {
                                                                byteNumbers[i] = slice.charCodeAt(
                                                                    i, // Convert to byte numbers
                                                                );
                                                            }
                                                            var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array
                                                            byteArrays.push(
                                                                byteArray, // Push byte array to the array
                                                            );
                                                        }
                                                        var blob = new Blob(byteArrays, {
                                                            type: contentType, // Create blob with content type
                                                        });
                                                        return blob; // Return blob
                                                    }
                                                    var contentType = 'application/pdf'; // PDF content type
                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                    var blob = b64toBlob(
                                                        b64Data,
                                                        contentType, // Convert base64 to blob
                                                    );
                                                    var file = window.URL.createObjectURL(
                                                        blob, // Create object URL for blob
                                                    );
                                                    console.log(blob); // Log blob for debugging
                                                    document.querySelector('iframe').src = file; // Set iframe source to blob URL
                                                    var printWindow = window.open(
                                                        file,
                                                        '',
                                                        'width=800,height=500', // Open print window
                                                    );
                                                    printWindow.print(); // Trigger print
                                                },
                                            },
                                        );
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'BetShop/GetIncomes?FromId=' + cur_user + '&'; // API URL for fetching incomes
        var filter = ''; // Filter string
        var datePopup3 = []; // Array for date popup options
        var datePopup4 = []; // Array for type center position options
        var popupAdd = ''; // Variable for add income popup
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Current date formatted

        webix
            .ajax() // AJAX request to get concepts
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    datePopup3 = resp.Data; // Store concepts data
                    webix
                        .ajax() // AJAX request to get types center position
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect',
                            '{"Type":2}', // Send request with type
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var resp = JSON.parse(text); // Parse response
                                    datePopup4 = resp.Data; // Store types data
                                    popupAdd = webix.ui({
                                        // Create add income popup
                                        view: 'window',
                                        width: 750,
                                        id: 'AddIncomes', // Popup ID
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Añadir Gasto'), // Localized title
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close', // Close icon
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close action
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Center position
                                        modal: true, // Modal window
                                        body: {
                                            view: 'form', // Form view
                                            id: 'addform', // Form ID
                                            elements: [
                                                {
                                                    margin: 10,
                                                    cols: [
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Descripción', // Localized label
                                                            ),
                                                            name: 'Description', // Input name
                                                            labelWidth: 140,
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Fecha de Creación', // Localized label
                                                            ),
                                                            labelWidth: 140,
                                                            name: 'CreatedLocalDate', // Input name
                                                            value: createdLocalDate, // Set current date
                                                            readonly: true, // Read-only field
                                                        },
                                                    ],
                                                },
                                                {
                                                    margin: 10,
                                                    cols: [
                                                        {
                                                            view: 'combo',
                                                            label: _(
                                                                'Tipo de Ingreso', // Localized label
                                                            ),
                                                            name: 'TypeIncomes', // Input name
                                                            labelWidth: 140,
                                                            options: datePopup4, // Options for combo
                                                            required: true, // Required field
                                                        },
                                                    ],
                                                },
                                                {
                                                    margin: 10,
                                                    cols: [
                                                        {
                                                            view: 'combo',
                                                            label: _(
                                                                'Concepto', // Localized label
                                                            ),
                                                            name: 'Concept', // Input name
                                                            labelWidth: 140,
                                                            options: datePopup3, // Options for combo
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Documento ID', // Localized label
                                                            ),
                                                            name: 'DocumentID', // Input name
                                                            labelWidth: 140,
                                                            required: false, // Not required
                                                        },
                                                    ],
                                                },
                                                {
                                                    margin: 10,
                                                    cols: [
                                                        {
                                                            view: 'text',
                                                            label: _('Valor'), // Localized label
                                                            name: 'Value', // Input name
                                                            type: 'number', // Input type
                                                            labelWidth: 100,
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Impuesto', // Localized label
                                                            ),
                                                            name: 'Iva', // Input name
                                                            type: 'number', // Input type
                                                            labelWidth: 100,
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Retracción', // Localized label
                                                            ),
                                                            name: 'Retraccion', // Input name
                                                            type: 'number', // Input type
                                                            labelWidth: 100,
                                                            required: true, // Required field
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _(
                                                                'Cancelar', // Localized label
                                                            ),
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close action
                                                                $$('addform').setValues(
                                                                    $$('addform').getCleanValues(), // Clear form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Guardar'), // Localized label
                                                            click: function ($e) {
                                                                var values = $$('addform').getValues(); // Get form values
                                                                if (
                                                                    $$('addform').validate() // Validate form
                                                                ) {
                                                                    webix
                                                                        .ajax() // AJAX request to save income
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() + 'BetShop/Incomes',
                                                                            '{"Description":"' +
                                                                                values.Description +
                                                                                '", "CreatedLocalDate":"' +
                                                                                values.CreatedLocalDate +
                                                                                '", "TypeIncomes":"' +
                                                                                values.TypeIncomes +
                                                                                '"  , "BetShop":"' +
                                                                                cur_user +
                                                                                '" , "Concept":"' +
                                                                                values.Concept +
                                                                                '" , "DocumentID":"' +
                                                                                values.DocumentID +
                                                                                '"  , "Value":"' +
                                                                                values.Value +
                                                                                '", "Iva":"' +
                                                                                values.Iva +
                                                                                '", "Retraccion":"' +
                                                                                values.Retraccion +
                                                                                '"}',
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        _(
                                                                                            'Error! ', // Show error message
                                                                                        ),
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        _(
                                                                                            'Gasto Agregado', // Show success message
                                                                                        ),
                                                                                    );
                                                                                    grid.clearAll(); // Clear grid data
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                    webix
                                                                                        .ui({
                                                                                            view: 'window',
                                                                                            width: 500,
                                                                                            height: 700,
                                                                                            head: {
                                                                                                view: 'toolbar',
                                                                                                cols: [
                                                                                                    {
                                                                                                        view: 'label',
                                                                                                        label: _(
                                                                                                            'Factura', // Localized title
                                                                                                        ),
                                                                                                    },
                                                                                                    {
                                                                                                        view: 'button',
                                                                                                        label: 'X', // Close button
                                                                                                        width: 100,
                                                                                                        align: 'right',
                                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                            id: 'windowfact2', // Window ID
                                                                                            modal: true, // Modal window
                                                                                            position: 'center', // Center position
                                                                                            body: {
                                                                                                rows: [
                                                                                                    {
                                                                                                        template:
                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                        })
                                                                                        .show(); // Show the window
                                                                                    var reader = new FileReader(); // FileReader for reading the PDF
                                                                                    reader.onload = function (event) {
                                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                                        $$('pdf').parse({
                                                                                            data: event.target.result, // Parse new PDF data
                                                                                        });
                                                                                    };
                                                                                    function b64toBlob(
                                                                                        b64Data,
                                                                                        contentType,
                                                                                        sliceSize,
                                                                                    ) {
                                                                                        contentType = contentType || ''; // Default content type
                                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                                        var byteCharacters =
                                                                                            atob(b64Data); // Decode base64
                                                                                        var byteArrays = []; // Array for byte arrays
                                                                                        for (
                                                                                            var offset = 0;
                                                                                            offset <
                                                                                            byteCharacters.length;
                                                                                            offset += sliceSize
                                                                                        ) {
                                                                                            var slice =
                                                                                                byteCharacters.slice(
                                                                                                    offset,
                                                                                                    offset + sliceSize,
                                                                                                ); // Slice byte characters
                                                                                            var byteNumbers = new Array(
                                                                                                slice.length,
                                                                                            ); // Create byte numbers array
                                                                                            for (
                                                                                                var i = 0;
                                                                                                i < slice.length;
                                                                                                i++
                                                                                            ) {
                                                                                                byteNumbers[i] =
                                                                                                    slice.charCodeAt(i); // Convert to byte numbers
                                                                                            }
                                                                                            var byteArray =
                                                                                                new Uint8Array(
                                                                                                    byteNumbers,
                                                                                                ); // Create Uint8Array
                                                                                            byteArrays.push(
                                                                                                byteArray, // Push byte array to the array
                                                                                            );
                                                                                        }
                                                                                        var blob = new Blob(
                                                                                            byteArrays,
                                                                                            {
                                                                                                type: contentType, // Create blob with content type
                                                                                            },
                                                                                        );
                                                                                        return blob; // Return blob
                                                                                    }
                                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                                    var blob = b64toBlob(
                                                                                        b64Data,
                                                                                        contentType, // Convert base64 to blob
                                                                                    );
                                                                                    var file =
                                                                                        window.URL.createObjectURL(
                                                                                            blob, // Create object URL for blob
                                                                                        );
                                                                                    console.log(blob); // Log blob for debugging
                                                                                    document.querySelector(
                                                                                        'iframe',
                                                                                    ).src = file; // Set iframe source to blob URL
                                                                                    var printWindow = window.open(
                                                                                        file,
                                                                                        '',
                                                                                        'width=800,height=500', // Open print window
                                                                                    );
                                                                                    printWindow.print(); // Trigger print
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('addform').setValues(
                                                                        $$('addform').getCleanValues(), // Clear form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Close action
                                                                } else {
                                                                    webix.message({
                                                                        title: _(
                                                                            '¡Error!', // Show error title
                                                                        ),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Completa los campos...', // Show error message
                                                                        ),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    });
                                },
                            },
                        );
                },
            });
        this.on(this.app, 'incomes:filter', (filterData) => {
            // Event listener for filtering incomes
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        var popup = webix.ui({
            // Create edit income popup
            view: 'window',
            width: 750,
            id: 'EditIncomes', // Popup ID
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Gasto') }, // Localized title
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Close action
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal window
            body: {
                view: 'form', // Form view
                id: 'editForm', // Form ID
                elements: [
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: 'ID', // Label for ID
                                name: 'Id', // Input name
                                readonly: true, // Read-only field
                                labelWidth: 140,
                            },
                            {
                                view: 'text',
                                label: _('Descripción'), // Localized label
                                name: 'Description', // Input name
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: _('Fecha de Creación'), // Localized label
                                labelWidth: 140,
                                name: 'CreatedLocalDate', // Input name
                                readonly: true, // Read-only field
                            },
                            {
                                view: 'text',
                                label: _('Tipo de Ingreso'), // Localized label
                                name: 'TypeIncomes', // Input name
                                readonly: true, // Read-only field
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: _('Documento ID'), // Localized label
                                name: 'DocumentID', // Input name
                                readonly: true, // Read-only field
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'combo',
                                label: _('Concepto'), // Localized label
                                name: 'Concept', // Input name
                                labelWidth: 140,
                                readonly: true, // Read-only field
                            },
                            {
                                view: 'text',
                                label: _('Valor'), // Localized label
                                name: 'Value', // Input name
                                type: 'number', // Input type
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: _('Impuesto'), // Localized label
                                name: 'Iva', // Input name
                                type: 'number', // Input type
                                labelWidth: 140,
                            },
                            {
                                view: 'text',
                                label: _('Retracción'), // Localized label
                                name: 'Retraccion', // Input name
                                type: 'number', // Input type
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    this.getTopParentView().hide(); // Close action
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Clear form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to update income
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'BetShop/Incomes',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "IsBetShop":"' +
                                                values.IsBetShop +
                                                '", "Description":"' +
                                                values.Description +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "TypeIncomes":"' +
                                                values.TypeIncomes +
                                                '"  , "BetShop":"' +
                                                cur_user +
                                                '"  , "DocumentID":"' +
                                                values.DocumentID +
                                                '"  , "Value":"' +
                                                values.Value +
                                                '", "Iva":"' +
                                                values.Iva +
                                                '", "Retraccion":"' +
                                                values.Retraccion +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Gasto Actualizado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Clear form values
                                    );
                                    this.getTopParentView().hide(); // Close action
                                },
                            },
                        ],
                    },
                ],
            },
        });
        this.on(this.app, 'AddIncome:button', (filter) => {
            // Event listener for add income button
            $$('addform').clearValidation(); // Clear validation
            popupAdd.show(); // Show add income popup
        });
        $$('editForm').bind($$('datatable')); // Bind edit form to DataTable
    }
}

// FILE DOCUMENTED
